import React from "react";

export default function CreatePatient() {
  return (
    <>
      <p>Create Patient here</p>
    </>
  );
}
